import { generateKeys, generateLocalization } from '../utils';
import { fundingCategories } from './documents';
import { safechargePaymentTypes, kalixaPaymentTypes, cryptoPaymentOptions, payzoffPaymentOptions, nganLuongPaymentMethods, bridgerPayPaymentTypes, cardpayPaymentTypes, dusupayPaymentTypes, powercash21PaymentTypes, jmFinancialPaymentTypes, easypayPaymentTypes, ubiqpayPaymentTypes, beetellerPaymentTypes, wallettecPaymentTypes, } from './payments';
export const bonusOfferTypes = generateKeys({
    adminBonus: {
        value: 'admin_bonus',
        label: 'Admin Bonus',
    },
    onDeposit: {
        value: 'ondeposit',
        label: 'On Deposit Bonus',
    },
    onBoard: {
        value: 'onboard',
        label: 'On Board Bonus',
    },
});
const _depositFlowTypes = {
    urlRedirect: {
        value: 'url_redirect',
        label: 'URL redirect',
    },
    dataPost: {
        value: 'data_post',
        label: 'Submitting a form via POST',
    },
    custom: {
        value: 'custom',
        label: 'Custom deposit form with virtual page fallback',
    },
    cryptoAddress: {
        value: 'crypto_address',
        label: 'Direct crypto address',
    },
    cardNative: {
        value: 'card_native',
        label: 'Native card UI',
    },
    bankWire: {
        value: 'bank_wire',
        label: 'Bank Wire',
    },
};
export const depositFlowTypes = generateKeys(_depositFlowTypes);
export const bonusOfferStatuses = generateKeys({
    pending: {
        value: 'pending',
        label: 'Pending',
        viewableByClient: false,
    },
    userApproved: {
        value: 'user_approved',
        label: 'User Approved',
        viewableByClient: true,
    },
    userRejected: {
        value: 'user_rejected',
        label: 'User Rejected',
        viewableByClient: false,
    },
    autoApproved: {
        value: 'auto_approved',
        label: 'Preapproved',
        viewableByClient: true,
    },
    clientAccepted: {
        value: 'client_accepted',
        label: 'Client Accepted',
        viewableByClient: true,
    },
    clientRejected: {
        value: 'client_rejected',
        label: 'Client Rejected',
        viewableByClient: true,
    },
});
export const depositVendors = generateLocalization('depositVendors', generateKeys({
    bonus: {
        value: 'bonus',
        acronym: 'BON',
        label: 'Bonus',
        isRealDeposit: false,
        manuallyCreated: false,
        clientPermitted: false,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    manual: {
        value: 'admin deposit',
        acronym: 'ADD',
        label: 'Deposit',
        isRealDeposit: true,
        manuallyCreated: true,
        clientPermitted: false,
        fundingCategory: fundingCategories.bankWire.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    transferDepositCommisions: {
        value: 'transfer_deposit_commisions',
        acronym: 'TDC',
        label: 'Transfer Deposit Commissions',
        isRealDeposit: false,
        manuallyCreated: true,
        isTransfer: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    localDepositorCommisions: {
        value: 'local_depositor_commisions',
        acronym: 'LDC',
        label: 'Local Depositor Commissions',
        isRealDeposit: false,
        manuallyCreated: true,
        isTransfer: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    transfer: {
        value: 'transfer',
        acronym: 'TRA',
        label: 'Transfer Deposit',
        isRealDeposit: false,
        manuallyCreated: true,
        isTransfer: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    transferb2b: {
        value: 'transferb2b',
        acronym: 'B2B',
        label: 'Transfer Deposit B2B',
        isRealDeposit: false,
        manuallyCreated: true,
        isTransfer: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    kalixa: {
        value: 'kalixa',
        acronym: 'KAL',
        label: 'Kalixa',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: false,
        options: kalixaPaymentTypes,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    skrill: {
        value: 'skrill',
        acronym: 'SKR',
        label: 'Skrill',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: false,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.eWallet.value,
        localization: { id: '', defaultMessage: '' },
    },
    wirecard: {
        value: 'wirecard',
        acronym: 'WIR',
        label: 'Wirecard',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: false,
        fundingCategory: fundingCategories.card.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    spreedly: {
        value: 's-wirecard',
        acronym: 'SWR',
        label: 'S-wirecard',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: false,
        fundingCategory: fundingCategories.card.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    codapay: {
        value: 'codapay',
        acronym: 'COD',
        label: 'Codapay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    dinpay: {
        value: 'dinpay',
        acronym: 'DIN',
        label: 'Dinpay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    fasapay: {
        value: 'fasapay',
        acronym: 'FAS',
        label: 'Fasapay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.eWallet.value,
        localization: { id: '', defaultMessage: '' },
        deprecated: true,
    },
    dlocal: {
        value: 'dlocal',
        acronym: 'DLO',
        label: 'Dlocal',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    dotpay: {
        value: 'dotpay',
        acronym: 'DOT',
        label: 'Dotpay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    zotapay: {
        value: 'zotapay',
        acronym: 'ZOT',
        label: 'Zotapay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        supportedGroupCountries: ['my', 'id', 'vn', 'th'],
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    divepay: {
        value: 'divepay',
        acronym: 'DIV',
        label: 'Divepay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    paycv: {
        value: 'paycv',
        acronym: 'PCV',
        label: 'PayCV',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    astropay: {
        value: 'astropay',
        acronym: 'AST',
        label: 'AstroPay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    link4pay: {
        value: 'link4pay',
        acronym: 'L4P',
        label: 'Link4Pay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        otc: true,
        localization: { id: '', defaultMessage: '' },
    },
    paytrust: {
        value: 'paytrust',
        acronym: 'PTR',
        label: 'PayTrust',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    coinbase: {
        value: 'coinbase',
        acronym: 'COB',
        label: 'Coinbase',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        isCrypto: true,
        options: cryptoPaymentOptions,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    recurly: {
        value: 'recurly',
        acronym: 'REC',
        label: 'Recurly Subscriptions',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        isSubscription: true,
        localization: { id: '', defaultMessage: '' },
    },
    chargebee: {
        value: 'chargebee',
        acronym: 'CHB',
        label: 'Chargebee Subscriptions',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        isSubscription: true,
        localization: { id: '', defaultMessage: '' },
    },
    globepay: {
        value: 'globepay',
        acronym: 'GLO',
        label: 'Globepay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    uobatm: {
        value: 'uobatm',
        acronym: 'UOB',
        label: 'Uobatm',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    depositCommisions: {
        value: 'deposit_commisions',
        acronym: 'DPC',
        label: 'Deposit Commissions',
        isRealDeposit: false,
        manuallyCreated: true,
        clientPermitted: false,
        mt4Comment: 'IB Commission',
        localization: { id: '', defaultMessage: '' },
    },
    reimbursementSettlement: {
        value: 'reimbursement_settlement',
        acronym: 'SET',
        label: 'Reimbursement/Settlement',
        isRealDeposit: true,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    demoFunds: {
        value: 'demo_funds',
        acronym: 'DEM',
        label: 'Demo Funds',
        isRealDeposit: false,
        isDemoDeposit: true,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    adjustmentCorrection: {
        value: 'adjustment_correction',
        acronym: 'ADJ',
        label: 'Adjustment/Correction',
        isRealDeposit: false,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    funtopay: {
        value: 'funtopay',
        acronym: 'FTP',
        label: 'FunToPay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    neteller: {
        value: 'neteller',
        acronym: 'NET',
        label: 'Neteller',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        fundingCategory: fundingCategories.eWallet.value,
        localization: { id: '', defaultMessage: '' },
    },
    bond: {
        value: 'bond',
        acronym: 'BOND',
        label: 'Bond',
        isRealDeposit: false,
        manuallyCreated: false,
        clientPermitted: false,
        supportCurrencyConverstation: true,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    cashu: {
        label: 'CashU',
        acronym: 'CashU',
        value: 'cashu',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    cc: {
        label: 'CC',
        acronym: 'CC',
        value: 'cc',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    cqr: {
        label: 'Cqr',
        acronym: 'Cqr',
        value: 'cqr',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    creditCard: {
        label: 'CreditCard',
        acronym: 'CreditCard',
        value: 'credit_card',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    moneybookers: {
        label: 'MoneyBookers',
        acronym: 'MoneyBookers',
        value: 'moneybookers',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    qiwi: {
        label: 'Qiwi',
        acronym: 'Qiwi',
        value: 'qiwi',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    wallet1: {
        label: 'Wallet1',
        acronym: 'Wallet1',
        value: 'wallet1',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    wire: {
        label: 'Wire',
        acronym: 'Wire',
        value: 'wire',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    manualCrypto: {
        value: 'manual_crypto',
        acronym: 'MCR',
        label: 'Manual Crypto',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        options: cryptoPaymentOptions,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    payzoff: {
        value: 'payzoff',
        acronym: 'POF',
        label: 'Payzoff',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        options: payzoffPaymentOptions,
        deprecated: true,
        localization: { id: '', defaultMessage: '' },
    },
    safecharge: {
        value: 'safecharge',
        acronym: 'SFC',
        label: 'SafeCharge',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        options: safechargePaymentTypes,
        otc: true,
        localization: { id: '', defaultMessage: '' },
    },
    rpnpay: {
        value: 'rpnpay',
        acronym: 'RPN',
        label: 'RPNpay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    rave: {
        value: 'rave',
        acronym: 'RAV',
        label: 'Rave',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    paymentAsia: {
        value: 'paymentAsia',
        acronym: 'PA',
        label: 'Payment Asia',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    isignthis: {
        value: 'isignthis',
        acronym: 'IST',
        label: 'iSignthis',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        fundingCategory: fundingCategories.bankWire.value,
        localization: { id: '', defaultMessage: '' },
    },
    bdxBonus: {
        value: 'bdx_bonus',
        acronym: 'XBN',
        label: 'BDX Bonus',
        isRealDeposit: false,
        manuallyCreated: true,
        clientPermitted: false,
        fundingCategory: fundingCategories.bankWire.value,
        localization: { id: '', defaultMessage: '' },
    },
    bdxManual: {
        value: 'bdx_admin_deposit',
        acronym: 'XDP',
        label: 'BDX Deposit',
        isRealDeposit: true,
        manuallyCreated: true,
        clientPermitted: false,
        fundingCategory: fundingCategories.bankWire.value,
        localization: { id: '', defaultMessage: '' },
    },
    chargebackDeposit: {
        value: 'chargeback_deposit',
        acronym: 'CDP',
        label: 'Chargeback Deposit',
        isRealDeposit: true,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    depositReturnedFunds: {
        value: 'deposit_returned_funds',
        acronym: 'DRF',
        label: 'Returned Funds',
        isRealDeposit: true,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    easyeft: {
        value: 'easyeft',
        acronym: 'EFT',
        label: 'EasyEFT',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    nganLuong: {
        value: 'nganLuong',
        acronym: 'NLU',
        label: 'Ngan Luong',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        supportCurrencyConverstation: true,
        options: nganLuongPaymentMethods,
        localization: { id: '', defaultMessage: '' },
    },
    directa24: {
        value: 'directa24',
        acronym: 'DIR',
        label: 'Directa24',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    thunderxpay: {
        value: 'thunderxpay',
        acronym: 'TXP',
        label: 'ThunderxPay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    paypal: {
        value: 'paypal',
        acronym: 'PP',
        label: 'PayPal',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.eWallet.value,
        localization: { id: '', defaultMessage: '' },
    },
    cardpay: {
        value: 'cardpay',
        acronym: 'CP',
        label: 'CardPay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        options: cardpayPaymentTypes,
        otc: true,
        localization: { id: '', defaultMessage: '' },
    },
    bridgerPay: {
        value: 'bridgerPay',
        acronym: 'BP',
        label: 'BridgerPay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        options: bridgerPayPaymentTypes,
        localization: { id: '', defaultMessage: '' },
    },
    transferSpoa: {
        value: 'transferSpoa',
        acronym: 'SPOA',
        label: 'Transfer SPOA Deposit',
        isRealDeposit: false,
        manuallyCreated: true,
        isTransfer: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    transferSpoab2b: {
        value: 'transferSpoab2b',
        acronym: 'SPOAB',
        label: 'Transfer SPOA Deposit B2B',
        isRealDeposit: false,
        manuallyCreated: true,
        isTransfer: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    appex: {
        value: 'appex',
        acronym: 'APP',
        label: 'Appex',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.card.value,
        localization: { id: '', defaultMessage: '' },
    },
    help2pay: {
        value: 'help2pay',
        acronym: 'H2P',
        label: 'Help2Pay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    bankWire: {
        value: 'bankWire',
        acronym: 'BW',
        label: 'Bank Wire',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        fundingCategory: fundingCategories.bankWire.value,
        localization: { id: '', defaultMessage: '' },
    },
    payRetailers: {
        value: 'payRetailers',
        acronym: 'PRT',
        label: 'PayRetailers',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    checkout: {
        value: 'checkout',
        acronym: 'CHK',
        label: 'Checkout',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.card.value,
        otc: true,
        localization: { id: '', defaultMessage: '' },
    },
    dusupay: {
        value: 'dusupay',
        acronym: 'DSP',
        label: 'Dusupay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: false,
        options: dusupayPaymentTypes,
        localization: { id: '', defaultMessage: '' },
    },
    powercash21: {
        value: 'powercash21',
        acronym: 'PRC',
        label: 'Powercash21',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        options: powercash21PaymentTypes,
        localization: { id: '', defaultMessage: '' },
    },
    referralReward: {
        value: 'referralReward',
        acronym: 'RER',
        label: 'Refer and Earn Reward',
        isRealDeposit: false,
        manuallyCreated: false,
        clientPermitted: true,
        localization: { id: '', defaultMessage: '' },
    },
    btcproxy: {
        value: 'btcproxy',
        acronym: 'BTP',
        label: 'BTCProxy',
        isCrypto: true,
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.crypto.value,
        localization: { id: '', defaultMessage: '' },
    },
    copyTradingPerformanceFee: {
        value: 'copyTradingPerformanceFee',
        acronym: 'PFA',
        label: 'Performance Fee Adjustment',
        isRealDeposit: false,
        manuallyCreated: false,
        clientPermitted: false,
        supportCurrencyConverstation: false,
        localization: { id: '', defaultMessage: '' },
    },
    creditBonus: {
        value: 'credit_bonus',
        acronym: 'CRB',
        label: 'Credit Bonus',
        isRealDeposit: false,
        manuallyCreated: false,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    depositBonus: {
        value: 'deposit_bonus',
        acronym: 'DPB',
        label: 'Deposit Bonus',
        isRealDeposit: false,
        manuallyCreated: false,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    klarpay: {
        value: 'klarpay',
        acronym: 'BW',
        label: 'Bank Transfers/Klarpay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    jmFinancial: {
        value: 'jmFinancial',
        acronym: 'JMF',
        label: 'JM Financial',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        options: jmFinancialPaymentTypes,
        signatureRequired: true,
        localization: { id: '', defaultMessage: '' },
    },
    bitnukCryptoTopup: {
        value: 'bitnuk_crypto_topup',
        acronym: 'BCT',
        label: 'Bitnuk/Crypto Topup',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        allowCompleteRejected: false,
        fundingCategory: fundingCategories.crypto.value,
        localization: { id: '', defaultMessage: '' },
    },
    bitnukBuyCrypto: {
        value: 'bitnuk_buy_crypto',
        acronym: 'BBC',
        label: 'Bitnuk/Buy Crypto',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: false,
        allowCompleteRejected: false,
        fundingCategory: fundingCategories.crypto.value,
        localization: { id: '', defaultMessage: '' },
    },
    volt: {
        value: 'volt',
        acronym: 'BW',
        label: 'Volt/Bank transfer',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    mifinity: {
        value: 'mifinity',
        acronym: 'MFT',
        label: 'Mifinity',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    echelonpay: {
        value: 'echelonpay',
        acronym: 'ECH',
        label: 'Echelonpay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    loyaltyProgramBonus: {
        value: 'loyalty_program_bonus',
        acronym: 'LPB',
        label: 'Loyalty Program Bonus',
        isRealDeposit: false,
        manuallyCreated: false,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    exactly: {
        value: 'exactly',
        acronym: 'EXL',
        label: 'Exactly',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.card.value,
        localization: { id: '', defaultMessage: '' },
    },
    otc365: {
        value: 'otc365',
        acronym: 'OTC',
        label: 'OTC365',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    usepay: {
        value: 'usepay',
        acronym: 'USE',
        label: 'Usepay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    finrax: {
        value: 'finrax',
        acronym: 'FIN',
        label: 'Finrax',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: false,
        fundingCategory: fundingCategories.crypto.value,
        localization: { id: '', defaultMessage: '' },
    },
    easypay: {
        value: 'easypay',
        acronym: 'BW',
        label: 'Easypay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        options: easypayPaymentTypes,
        localization: { id: '', defaultMessage: '' },
    },
    dividend: {
        value: 'dividend',
        acronym: 'DVI',
        label: 'Dividend',
        isRealDeposit: true,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    unionpay: {
        value: 'unionpay',
        acronym: 'UNP',
        label: 'UnionPay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        localization: { id: '', defaultMessage: '' },
    },
    letknowpay: {
        value: 'letknowpay',
        acronym: 'LNP',
        label: 'LetKnowPay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.crypto.value,
        localization: { id: '', defaultMessage: '' },
    },
    speedlightpay: {
        value: 'speedlightpay',
        acronym: 'SLP',
        label: 'SpeedLightpay - Crypto',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.crypto.value,
        localization: { id: '', defaultMessage: '' },
    },
    transact365: {
        value: 'transact365',
        acronym: 'T365',
        label: 'Transact365',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        kycRequired: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    cellulant: {
        value: 'cellulant',
        acronym: 'CELL',
        label: 'Cellulant',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    razorpay: {
        value: 'razorpay',
        acronym: 'EZP',
        label: 'Indian Local Methods - Easypay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    korapay: {
        value: 'korapay',
        acronym: 'KRP',
        label: 'Korapay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        fundingCategory: fundingCategories.onlineBanking.value,
        localization: { id: '', defaultMessage: '' },
    },
    losableCreditBonus: {
        value: 'losable_credit_bonus',
        acronym: 'LCB',
        label: 'Losable Credit Bonus',
        isRealDeposit: false,
        manuallyCreated: false,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    cashBonus: {
        value: 'cashBonus',
        acronym: 'CBN',
        label: 'Cash bonus',
        isRealDeposit: false,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    cashGift: {
        value: 'cashGift',
        acronym: 'CG',
        label: 'Cash Gift',
        isRealDeposit: false,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    creditInAdvance: {
        value: 'credit_in_advance',
        acronym: 'CIA',
        label: 'Credit In Advance',
        isRealDeposit: false,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    ubiqpay: {
        value: 'ubiqpay',
        acronym: 'UBQ',
        label: 'UbiqPay',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        options: ubiqpayPaymentTypes,
        localization: { id: '', defaultMessage: '' },
    },
    beeteller: {
        value: 'beeteller',
        acronym: 'BTL',
        label: 'Beeteller',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        options: beetellerPaymentTypes,
        localization: { id: '', defaultMessage: '' },
    },
    ldTransfer: {
        value: 'ldTransfer',
        acronym: 'LDT',
        label: 'Local Depositor Transfer',
        isRealDeposit: false,
        manuallyCreated: true,
        isTransfer: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    ibExpenses: {
        value: 'ib_expenses',
        acronym: 'IB-Expenses',
        label: 'IB Expenses',
        isRealDeposit: false,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    contractorSalary: {
        value: 'contractor_salary',
        acronym: 'Con-Sal',
        label: 'Contractor Salary',
        isRealDeposit: false,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    contractorExpenses: {
        value: 'contractor_expenses',
        acronym: 'Con-Expenses',
        label: 'Contractor Expenses',
        isRealDeposit: false,
        manuallyCreated: true,
        clientPermitted: false,
        localization: { id: '', defaultMessage: '' },
    },
    wallettec: {
        value: 'wallettec',
        acronym: 'WLT',
        label: 'Wallettec',
        isRealDeposit: true,
        manuallyCreated: false,
        clientPermitted: true,
        allowCompleteRejected: true,
        options: wallettecPaymentTypes,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const depositStatuses = generateLocalization('depositStatuses', generateKeys({
    awaitingPayment: {
        value: 8,
        label: 'Awaiting Payment',
        labelWeb: 'Awaiting Payment',
        localization: { id: '', defaultMessage: '' },
    },
    partiallyReversed: {
        value: 7,
        label: 'Partially Reversed',
        labelWeb: 'Partially Reversed',
        localization: { id: '', defaultMessage: '' },
    },
    reversed: {
        value: 6,
        label: 'Reversed',
        labelWeb: 'Reversed',
        localization: { id: '', defaultMessage: '' },
    },
    processing: {
        value: 5,
        label: 'Processing',
        labelWeb: 'Processing',
        localization: { id: '', defaultMessage: '' },
    },
    incomplete: {
        value: 4,
        label: 'Incomplete',
        labelWeb: 'Processing',
        localization: { id: '', defaultMessage: '' },
    },
    held: {
        value: 3,
        label: 'Held',
        localization: { id: '', defaultMessage: '' },
    },
    completed: {
        value: 2,
        label: 'Completed',
        localization: { id: '', defaultMessage: '' },
    },
    authorized: {
        value: 1,
        label: 'Authorized',
        localization: { id: '', defaultMessage: '' },
    },
    pending: {
        value: 0,
        label: 'Attempted',
        localization: { id: '', defaultMessage: '' },
    },
    cancelled: {
        value: -1,
        label: 'Cancelled',
        localization: { id: '', defaultMessage: '' },
    },
    failed: {
        value: -2,
        label: 'Failed',
        localization: { id: '', defaultMessage: '' },
    },
    chargeback: {
        value: -3,
        label: 'Chargeback',
        localization: { id: '', defaultMessage: '' },
    },
    rejected: {
        value: -4,
        label: 'Rejected',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const transferTypes = generateLocalization('transferTypes', generateKeys({
    nonTransfers: {
        label: 'Non transfers',
        localization: { id: '', defaultMessage: '' },
    },
    transfers: {
        label: 'Transfers',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const beginDepositResults = generateKeys({
    pending: {
        value: 'pending',
    },
    success: {
        value: 'success',
    },
    failed: {
        value: 'failed',
    },
    cancelled: {
        value: 'cancelled',
    },
});
export const processDepositResults = generateKeys({
    complete: {
        value: 'complete',
        label: 'Complete',
    },
    fail: {
        value: 'fail',
        label: 'Fail',
    },
    hold: {
        value: 'hold',
        label: 'Hold',
    },
    incomplete: {
        value: 'incomplete',
        label: 'Incomplete',
    },
    pending: {
        value: 'pending',
        label: 'Pending',
    },
});
export const depositTypeOptions = generateKeys({
    bankWire: {
        value: 'bankwire',
        label: 'Bank Wire',
    },
    other: {
        value: 'other',
        label: 'Other',
    },
});
export const cryptoTransactionTypes = generateLocalization('cryptoTransactionTypes', generateKeys({
    buy: {
        value: 'buy',
        label: 'Buy',
        localization: { id: '', defaultMessage: '' },
    },
    sell: {
        value: 'sell',
        label: 'Sell',
        localization: { id: '', defaultMessage: '' },
    },
    transferOut: {
        value: 'transfer_out',
        label: 'Transfer to',
        userUpdatable: false,
        localization: { id: '', defaultMessage: '' },
    },
    transferIn: {
        value: 'transfer_in',
        label: 'Transfer from',
        userUpdatable: false,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const cryptoTransactionStatuses = generateLocalization('cryptoTransactionStatuses', generateKeys({
    incomplete: {
        value: 4,
        label: 'Incomplete',
        labelWeb: 'Processing',
        localization: { id: '', defaultMessage: '' },
    },
    held: {
        value: 3,
        label: 'Held',
        localization: { id: '', defaultMessage: '' },
    },
    completed: {
        value: 2,
        label: 'Completed',
        localization: { id: '', defaultMessage: '' },
    },
    pending: {
        value: 0,
        label: 'Pending',
        localization: { id: '', defaultMessage: '' },
    },
    cancelled: {
        value: -1,
        label: 'Cancelled',
        localization: { id: '', defaultMessage: '' },
    },
    failed: {
        value: -2,
        label: 'Failed',
        localization: { id: '', defaultMessage: '' },
    },
    rejected: {
        value: -4,
        label: 'Rejected',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const refundStatuses = generateKeys({
    full: {
        value: 'full',
        message: 'Full Refund',
    },
    partial: {
        value: 'partial',
        message: 'Partial Refund',
    },
    none: {
        value: 'none',
        message: 'Not refunded',
    },
});
export const depositRejectionReasons = generateLocalization('depositRejectionReasons', generateKeys({
    daysPassed: {
        value: 'daysPassed',
        label: '10 working days have passed and no documents/information provided',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    archivedAccount: {
        value: 'archivedAccount',
        label: 'Archived account',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    insufficientFunds: {
        value: 'insufficientFunds',
        label: 'Insufficient Funds',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    accountClosure: {
        value: 'accountClosure',
        label: 'Account closure',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    fraud: {
        value: 'fraud',
        label: 'Fraud',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    underage: {
        value: 'underage',
        label: 'Underage',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    perRequest: {
        value: 'perRequest',
        label: 'As per request',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    perCompliance: {
        value: 'perCompliance',
        label: 'As per compliance',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    notAcceptableCountry: {
        value: 'notAcceptableCountry',
        label: 'Not acceptable country',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        disabled: false,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const depositHeldReasons = generateLocalization('depositHeldReasons', generateKeys({
    appropTestMissing: {
        value: 'appropTestMissing',
        label: 'You have not completed your Appropriateness test or is rejected',
        internalLabel: 'Approp Test is Missing or is Rejected',
        action: 'complete',
        localization: { id: '', defaultMessage: '' },
    },
    economicProfileMissing: {
        value: 'economicProfileMissing',
        label: 'You have not completed your Economic Profile',
        internalLabel: 'Economic Profile is Missing',
        action: 'complete',
        localization: { id: '', defaultMessage: '' },
    },
    underMonitoring: {
        value: 'underMonitoring',
        label: 'You have failed to provide us with additional documentation/information or confirmation - please check your emails or contact us for further assistance.',
        internalLabel: 'Account is Under Monitoring',
        localization: { id: '', defaultMessage: '' },
    },
    cryptocoin: {
        value: 'cryptocoin',
        label: 'Your deposit is pending, as further action is required from your side. For more information, please check your Dashboard and email',
        internalLabel: 'Cryptocoin config',
        localization: { id: '', defaultMessage: '' },
    },
    kycStatus: {
        value: 'kycStatus',
        label: 'Your verification documents were not approved and/or are under review',
        internalLabel: 'KYC Status is {status}',
        localization: { id: '', defaultMessage: '' },
    },
    tradingStatus: {
        value: 'tradingStatus',
        label: 'You have failed to provide us with additional documentation/information or confirmation - please check your emails or contact us for further assistance.',
        internalLabel: 'Trading Status is {status}',
        localization: { id: '', defaultMessage: '' },
    },
    depositLimit: {
        value: 'depositLimit',
        label: 'You did not submit your verification documents',
        internalLabel: 'Deposit limit of {limit} before KYC reached',
        action: 'submit_btn',
        localization: { id: '', defaultMessage: '' },
    },
    manualDeposits: {
        value: 'manualDeposits',
        label: 'Manual Deposits',
        internalLabel: 'Account is Under Manual Deposits',
        localization: { id: '', defaultMessage: '' },
    },
    nameMismatch: {
        value: 'nameMismatch',
        label: 'Name Mismatch',
        internalLabel: 'Vendor callback name mismatch',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const bankWireBanks = generateKeys({
    astrobank: {
        acronym: 'AST',
        label: 'Astro Bank',
        value: 'astrobank',
    },
    isignthis: {
        acronym: 'IST',
        label: 'iSignthis',
        value: 'isignthis',
    },
    coutts: {
        acronym: 'CTS',
        label: 'Coutts',
        value: 'coutts',
    },
    wirecard: {
        acronym: 'WCB',
        label: 'Wirecard Bank',
        value: 'wirecard',
    },
    handels: {
        acronym: 'HLS',
        label: 'Handels Bank',
        value: 'handels',
    },
    sbm: {
        acronym: 'SBM',
        label: 'SBM',
        value: 'sbm',
    },
    eurobank: {
        acronym: 'EUB',
        label: 'Eurobank',
        value: 'eurobank',
    },
    paystree: {
        acronym: 'PST',
        label: 'Paystree',
        value: 'paystree',
    },
    vialet: {
        acronym: 'VIA',
        label: 'Vialet',
        value: 'vialet',
    },
    reserveTrust: {
        acronym: 'RST',
        label: 'Paypugs - Reserve Trust',
        value: 'reserveTrust',
    },
    spectrum: {
        acronym: 'SPC',
        label: 'Spectrum',
        value: 'spectrum',
    },
    absa: {
        acronym: 'ABS',
        label: 'ABSA',
        value: 'ABSA',
    },
});
